import React from "react"
import { Navigate, useLocation, Outlet } from "react-router-dom"
import _ from "lodash"

import Header from "../Header"

export function ProtectedLayout({ allowRole }) {
  const location = useLocation()
  const loggedUser = JSON.parse(localStorage.getItem("user"))

  if (
    _.isEmpty(loggedUser) ||
    allowRole.every((role) => role !== loggedUser?.roles_id)
  ) {
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return (
    <>
      <Header />
      <Outlet />
    </>
  )
}
